import * as RadixTooltip from "@radix-ui/react-tooltip";
import type { JSX, ReactNode } from "react";

export interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
}

/**
 * Hover and focus hint. Used for an icon's name or an explanation whose consequence is
 * not obvious. Provider is local so the primitive works without an app-level wrapper.
 */
export function Tooltip({ content, children }: TooltipProps): JSX.Element {
  return (
    <RadixTooltip.Provider delayDuration={300}>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            sideOffset={6}
            className="z-50 rounded-small bg-ink px-2 py-1 text-sm text-canvas"
          >
            {content}
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}
